export default __webpack_public_path__ + "static/media/appfolio-logo.c55992a5.png";